import React from 'react';

// Types
import {
  FormTypeType,
  QuestionType,
  QuestionTypeType,
  ReviewFormTemplateType,
} from 'Shared/types/ReviewFormTemplate.type';

// Components
import TextareaQuestion from './TextareaQuestion';
import RatingQuestion from './RatingQuestion';
import SingleQuestionSummaryQuestion from './SingleQuestionSummaryQuestion';
import AdjectivesForPropertyQuestion from './AdjectivesForPropertyQuestion';
import GifQuestion from './GifQuestion';

type Props = {
  question: QuestionType;
  onChange: Function;
  handleDeleteQuestion: Function;
  handleDuplicateQuestion: Function;
  handleMoveQuestion: Function;
  activeQuestionKey: string;
  setActiveQuestionKey: Function;
  reviewFormType: FormTypeType;
  reviewFormTemplates: ReviewFormTemplateType[];
};

const Question = ({
  question,
  onChange,
  handleDeleteQuestion,
  handleMoveQuestion,
  activeQuestionKey,
  setActiveQuestionKey,
  handleDuplicateQuestion,
  reviewFormType,
  reviewFormTemplates,
}: Props) => {
  switch (question.type) {
    case QuestionTypeType.HOLISTIC_SUMMARY:
    case QuestionTypeType.TEXTAREA:
      return (
        <TextareaQuestion
          question={question}
          onChange={onChange}
          handleDeleteQuestion={handleDeleteQuestion}
          activeQuestionKey={activeQuestionKey}
          setActiveQuestionKey={setActiveQuestionKey}
          handleDuplicateQuestion={handleDuplicateQuestion}
          handleMoveQuestion={handleMoveQuestion}
          reviewFormType={reviewFormType}
          reviewFormTemplates={reviewFormTemplates}
        />
      );
    case QuestionTypeType.RATING:
      return (
        <RatingQuestion
          // @ts-ignore
          question={question}
          onChange={onChange}
          handleDeleteQuestion={handleDeleteQuestion}
          activeQuestionKey={activeQuestionKey}
          setActiveQuestionKey={setActiveQuestionKey}
          handleDuplicateQuestion={handleDuplicateQuestion}
          handleMoveQuestion={handleMoveQuestion}
          reviewFormType={reviewFormType}
          reviewFormTemplates={reviewFormTemplates}
        />
      );
    case QuestionTypeType.ADJECTIVES_FOR_PROPERTY_SUMMARY:
    case QuestionTypeType.RATING_SUMMARY:
      return (
        <SingleQuestionSummaryQuestion
          // @ts-ignore
          question={question}
          onChange={onChange}
          handleDeleteQuestion={handleDeleteQuestion}
          activeQuestionKey={activeQuestionKey}
          setActiveQuestionKey={setActiveQuestionKey}
          handleDuplicateQuestion={handleDuplicateQuestion}
          handleMoveQuestion={handleMoveQuestion}
          reviewFormType={reviewFormType}
          reviewFormTemplates={reviewFormTemplates}
        />
      );
    case QuestionTypeType.ADJECTIVES_FOR_PROPERTY:
      return (
        <AdjectivesForPropertyQuestion
          // @ts-ignore
          question={question}
          onChange={onChange}
          handleDeleteQuestion={handleDeleteQuestion}
          activeQuestionKey={activeQuestionKey}
          setActiveQuestionKey={setActiveQuestionKey}
          handleDuplicateQuestion={handleDuplicateQuestion}
          handleMoveQuestion={handleMoveQuestion}
          reviewFormTemplates={reviewFormTemplates}
          reviewFormType={reviewFormType}
        />
      );
    case QuestionTypeType.GIF:
      return (
        <GifQuestion
          question={question}
          onChange={onChange}
          handleDeleteQuestion={handleDeleteQuestion}
          activeQuestionKey={activeQuestionKey}
          setActiveQuestionKey={setActiveQuestionKey}
          handleDuplicateQuestion={handleDuplicateQuestion}
          handleMoveQuestion={handleMoveQuestion}
          reviewFormType={reviewFormType}
          reviewFormTemplates={reviewFormTemplates}
        />
      );
    default:
      return null;
  }
};

export default Question;
